import { GET_FUNDS_FAILED, GET_FUNDS_INIT, GET_FUNDS_SUCCESS, GET_FUND_DETAIL_FAILED, GET_FUND_DETAIL_INIT, GET_FUND_DETAIL_SUCCESS } from "./constants";
const initialState = {
  loading: false,
  fund: [],
  funds: [],
};
export default function fundCompare(state = initialState, action) {
  switch (action.type) {
    case GET_FUND_DETAIL_INIT:
      return { ...state, loading: true };
    case GET_FUND_DETAIL_SUCCESS:
      var fundList = [...state.fund , action.payload];
      return {
        ...state,
        loading: false,
        fund: fundList,
      };
    case GET_FUND_DETAIL_FAILED:
      return { ...state, loading: false };
    case GET_FUNDS_INIT:
      return { ...state, loading: true };
    case GET_FUNDS_SUCCESS:
      return {
        ...state,
        loading: false,
        funds: action.payload,
      };
    case GET_FUNDS_FAILED:
      return { ...state, loading: false };
    default:
      return state;
  }
}